import React from "react";
import { Add } from "@mui/icons-material";
import { HeaderButton } from "../../button/HeaderButton";
import { ManageTagDialog } from "../tags/ManageTagDialog";
import { TagType } from "../../../constants";

export interface CreateTagProps {
  disabled?: boolean;
  className?: string;
  useThemePalette?: boolean;
  tagType: TagType;
}
export function CreateTagAction(props: CreateTagProps) {
  const {
    disabled = false,
    className,
    useThemePalette = true,
    tagType,
  } = props;
  const [tagDialogOpen, setTagDialogOpen] = React.useState(false);

  const handleCreateExerciseTagClick = React.useCallback(() => {
    setTagDialogOpen(true);
  }, []);

  const handleCloseExerciseTagDialog = React.useCallback(() => {
    setTagDialogOpen(false);
  }, []);

  return (
    <>
      <HeaderButton
        startIcon={<Add />}
        onClick={handleCreateExerciseTagClick}
        disabled={disabled}
        className={className}
        useThemePalette={useThemePalette}
      >
        Create tag
      </HeaderButton>

      {tagDialogOpen && (
        <ManageTagDialog
          open={true}
          onClose={handleCloseExerciseTagDialog}
          tagType={tagType}
        />
      )}
    </>
  );
}
